module.exports = __webpack_public_path__ + "bq.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bq.svg
// module id = 717
// module chunks = 0